import { Achievement, Campaign } from '@/models/reward';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgRewardsExtras',
})
export default class CmgRewardsExtras extends Vue {
  async mounted() {
    const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();
    if (!isLoggedIn) {
      window.location.replace(`${window.location.origin}${this.$services.config.getRewardsPath()}`);
      return;
    }
    if (!this.$services.loyalty.isLoyaltyEligible(this.$appStore.state.customer.profile)) {
      this.$router.replace({ name: Routes.Rewards });
      return;
    }

    this.setLoadingStatus(true);
    Promise.all([this.$services.reward.getExtrasCampaigns(), this.$services.reward.getExtrasAchievements()])
      .finally(() => this.setLoadingStatus(false));
  }

  get achievements(): Achievement[] {
    return this.$appStore.state.reward.achievements;
  }

  get campaigns(): Campaign[] {
    return this.$appStore.state.reward.campaigns;
  }

  setLoadingStatus(loading: boolean) {
    this.$services.ui.setAppBlur(loading);
    this.$services.ui.setAppPepperVisibility(loading);
  }
}
